import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { AutomationsService } from '../services/automations.service';
import * as AutomationDetailsActions from './automation-details.actions';

@Injectable()
export class AutomationDetailsEffects {
  loadAutomationDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AutomationDetailsActions.loadAutomationDetails),
      mergeMap(action =>
        this.automationsService.getAutomationById(action.automationId).pipe(
          map(response => AutomationDetailsActions.loadAutomationDetailsSuccess({ automation: response.data })),
          catchError(error =>
            of(
              AutomationDetailsActions.loadAutomationDetailsFailure({
                error: error.message || 'Failed to load automation details',
              })
            )
          )
        )
      )
    )
  );

  updateAutomationDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AutomationDetailsActions.updateAutomationDetails),
      mergeMap(action =>
        this.automationsService.updateAutomation(action.automationId, action.data).pipe(
          map(response => AutomationDetailsActions.updateAutomationDetailsSuccess({ automation: response.data })),
          catchError(error =>
            of(
              AutomationDetailsActions.updateAutomationDetailsFailure({
                error: error.message || 'Failed to update automation details',
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private automationsService: AutomationsService
  ) {}
}
